<span class="snackbar-text"><mat-icon>warning</mat-icon> {{message}}</span>

<div class="snackbar-actions"
    [attr.data-cy]="warningSnackbarDataCy.SNACK_BAR">
    <button [buttonType]="'secondary'"
        *ngIf="secondaryActionLabel"
        (click)="secondaryAction()">{{secondaryActionLabel}}</button>

    <button [buttonType]="'primary'"
        *ngIf="hasAction"
        (click)="dismiss()">{{action}}</button>
</div>
